import { render, staticRenderFns } from "./Ellipsis.vue?vue&type=template&id=2db7d600&scoped=true"
import script from "./Ellipsis.vue?vue&type=script&lang=ts"
export * from "./Ellipsis.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./Ellipsis.vue?vue&type=style&index=0&id=2db7d600&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "2db7d600",
  "1c0e6c7d"
  
)

export default component.exports